module.exports = __webpack_public_path__ + "static/media/IR.ba7f9338.jpg";